module.exports = __webpack_public_path__ + "img/Winner-5.3ca51fcc.jpg";